export const PRESET_SEAT_LABELS = [
  'Standing room',
  'Limited leg room',
  'Obstructed view',
  'Restricted view',
  'Side view',
]

export function flattenSelectedSeatIds(selectedSeatIds) {
  const ids = []

  Object.values(selectedSeatIds?.seats || {}).forEach((list) => {
    if (Array.isArray(list)) ids.push(...list)
  })

  Object.values(selectedSeatIds?.gaSeats || {}).forEach((section) => {
    Object.values(section || {}).forEach((list) => {
      if (Array.isArray(list)) ids.push(...list)
    })
  })

  return [...new Set(ids.filter(Boolean))]
}

export function buildSeatLabelLookup(mapping, eventSeatLabels) {
  const labels = {}

  Object.entries(mapping?.seatLabels || {}).forEach(([seatId, label]) => {
    if (label) labels[seatId] = label
  })

  Object.values(mapping?.seats || {}).forEach((seat) => {
    if (seat?.seatId && seat?.additionalLabel) {
      labels[seat.seatId] = seat.additionalLabel
    }
  })

  Object.entries(eventSeatLabels || {}).forEach(([seatId, label]) => {
    if (label) labels[seatId] = label
  })

  return labels
}

export function labelsForSeatIds(seatIds, seatLabels) {
  const unique = [...new Set((seatIds || []).filter(Boolean))]
  const values = unique
    .map((seatId) => seatLabels?.[seatId] || '')
    .filter(Boolean)
  const uniqueValues = [...new Set(values)]

  if (!unique.length || uniqueValues.length === 0) {
    return { label: '', mixed: false }
  }
  if (uniqueValues.length === 1 && values.length === unique.length) {
    return { label: uniqueValues[0], mixed: false }
  }
  return { label: uniqueValues[0] || '', mixed: true }
}
